import { z } from "zod";

export const orderIdentificationSchema = z.object({
  orderName: z.string().min(1, "Le numéro de commande est requis"),
  secondaryInput: z.string().optional(),
});

export type OrderIdentificationFormValues = z.infer<
  typeof orderIdentificationSchema
>;
